function ErrorTracker() {
	function isAvailable() {
		if (typeof window !== 'object' || !window.Sentry) {
			return false;
		}
		return true;
	}

	function parseForKeys(e, keys) {
		for (var i = 0; i < keys.length; i++) {
			var k = keys[i];
			// No hit? Then skip
			if (!e[k]) continue;

			// Return the first string value
			if (typeof e[k] === 'string') {
				return e[k];
			}
			// If theres an array value join it and return it
			else if (e[k].join) {
				return e[k].join('; ');
			}
		}
	}

	function parseNonErrorException(e) {
		var msg;

		var priorityKeys = ['error', 'errors'];
		msg = parseForKeys(e, priorityKeys);
		if (msg) return msg;

		var keys = Object.keys(e);
		msg = parseForKeys(e, keys);
		if (msg) return msg;

		return 'Non-Error exception captured with keys: ' + keys.join(', ');
	}

	function addBreadcrumb(breadcrumb) {
		if (!isAvailable()) {
			console.debug('addBreadcrumb', breadcrumb);
			return;
		}
		window.Sentry.addBreadcrumb(breadcrumb);
	}

	function captureException(ex) {
		if (!isAvailable()) {
			console.error(ex);
			return;
		}
		if (ex instanceof Error) {
			window.Sentry.captureException(ex);
		} else {
			var msg = parseNonErrorException(ex);
			captureMessageWithExtra(msg, 'error', ex);
		}
	}

	function captureMessage(message, level) {
		if (!isAvailable()) {
			console.debug('captureMessage', message);
			return;
		}
		window.Sentry.captureMessage(message, level);
	}

	function captureMessageWithExtra(message, level, ctx) {
		ctx = ctx || {};
		if (!isAvailable()) {
			console.debug('captureMessageWithExtra', message, ctx);
			return;
		}
		// withScope will only send data with one specific event
		window.Sentry.withScope(function(scope) {
			scope.setExtras(ctx);
			captureMessage(message, level);
		});
	}

	// Add some extra context to this specific event:
	function captureExceptionWithExtra(ex, ctx) {
		ctx = ctx || {};
		if (!isAvailable()) {
			console.debug('captureExceptionWithExtra', ex, ctx);
			return;
		}
		// withScope will only send data with one specific event
		window.Sentry.withScope(function(scope) {
			scope.setExtras(ctx);
			captureException(ex);
		});
	}

	// Add some extra context on the global scope:
	function setExtraContext(ctx) {
		ctx = ctx || {};
		if (!isAvailable()) {
			console.debug('setExtraContext', ctx);
			return;
		}
		window.Sentry.configureScope(function(scope) {
			scope.setExtras(ctx);
		});
	}

	// Add user to the global scope:
	function setUser(user) {
		if (!isAvailable()) {
			console.debug('setUser', user);
			return;
		}
		window.Sentry.configureScope(function(scope) {
			scope.setUser(user);
		});
	}

	// Public functions:
	return {
		addBreadcrumb: addBreadcrumb,
		captureException: captureException,
		captureExceptionWithExtra: captureExceptionWithExtra,
		captureMessage: captureMessage,
		captureMessageWithExtra: captureMessageWithExtra,
		setExtraContext: setExtraContext,
		setUser: setUser,
	};
}

if (typeof require === 'function' && typeof exports !== 'undefined') {
	module.exports = ErrorTracker();
} else {
	define([], ErrorTracker);
}
